import { useState, useRef, useEffect } from "react";
import statusStore from "../../stores/statusStore";

export default function MobileEpisodeReview({selectedEpisode, reviewOverlayOpen, setReviewOverlayOpen}) {

    const staStore = statusStore();
    const [loading, setLoading] = useState(false);
    const [episodeReview, setEpisodeReview] = useState();

    // get all the tags for a user
    const tags = ["yellow", "red", "blue", "purple"];
    const [hoverRating, setHoverRating] = useState(0);
    const [query, setQuery] = useState("");
    const starContainerRef = useRef(null);
    const submittingRef = useRef(false);

    const [formData, setFormData] = useState({
        userStatus: "Watched",
        rating: null,
        note: "",
        tags: [],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const getStarValueFromEvent = (e) => {
        const container = starContainerRef.current;
        if (!container) return 0;

        const { left, width } = container.getBoundingClientRect();
        const relativeX = e.clientX - left;
        const percent = relativeX / width; // 0 to 1 across all 5 stars
        const rawValue = percent * 5;

        // round to nearest 0.5, clamped between 0.5 and 5
        const rounded = Math.ceil(rawValue * 2) / 2;
        return Math.min(5, Math.max(0.5, rounded));
    };

     const getStarIcon = (star, current) => {
        if (current >= star) return "/assets/icons/stars/star-full.png";
        if (current >= star - 0.5) return "/assets/icons/stars/star-half.png";
        return "/assets/icons/stars/star-empty.png";
    };

    const handleRatingClick = (star) => {
        setFormData((prev) => {
            let next = star;

            if (prev.rating === star) next = star - 0.5;       // full -> half
            else if (prev.rating === star - 0.5) next = star;  // half -> full

            return { ...prev, rating: next };
        });
        setHoverRating(0); // so the hover preview doesn't hide the change
    };

    const addTag = (tag) => {
        if (!tag || formData.tags.includes(tag)) return;
        setFormData((prev) => ({ ...prev, tags: [...prev.tags, tag] }));
    };

    const removeTag = (tag) => {
        setFormData((prev) => ({
        ...prev,
        tags: prev.tags.filter((t) => t !== tag),
        }));
    };

    const handleSubmit = async() => {

        if (submittingRef.current) return;   // block the second click
        submittingRef.current = true;
        setLoading(true);

        try {

            // Check if their is a current review that should be updated
            if (selectedEpisode.status) {
                await staStore.updateEpisodeStatus(
                    selectedEpisode.status._id,
                    selectedEpisode.seriesId, 
                    selectedEpisode.seasonNumber, 
                    selectedEpisode.episodeNumber, 
                    selectedEpisode._id, 
                    "episode", 
                    "Watched",
                    formData.rating,
                    formData.note,
                    formData.tags
                );
                
            }
            // Make a new review
            else { 
                await staStore.createEpisodeStatus(
                    selectedEpisode.seriesId, 
                    selectedEpisode.seasonNumber, 
                    selectedEpisode.episodeNumber, 
                    selectedEpisode._id, 
                    "episode", 
                    "Watched",
                    formData.rating,
                    formData.note,
                    formData.tags
                );
                
            }
        
            setFormData({
                seriesId: "",
                userStatus: "",
                rating: null,
                note: "",
                tags: [],
            });

            setReviewOverlayOpen(false);
        } catch (err) {
            console.error(err);
            // add an error message here 
        } finally {
            submittingRef.current = false;
            setLoading(false);
        }
    };

    const filteredTags = tags?.filter((tag) =>
        tag.toLowerCase().includes((query || "").toLowerCase()) &&
        !formData.tags.includes(tag)
    );

    useEffect(() => {
        if (!selectedEpisode) return;

        console.log("Running the correct useEffect..");

        const existingStatus = selectedEpisode.status;
        console.log("existing status ", existingStatus);

        setFormData((prev) => ({
            ...prev,
            seriesId: selectedEpisode.seriesId,
            userStatus: existingStatus?.userStatus ?? "Watched",
            rating: existingStatus?.rating ?? null,
            note: existingStatus?.review ?? "",
            tags: existingStatus?.tags ?? [],
        }));
    }, [selectedEpisode]);

    useEffect(() => {
        console.log("Use effect status selected episode ", selectedEpisode?.status);
        setEpisodeReview(selectedEpisode?.status);
    }, [reviewOverlayOpen]);

    const [dragY, setDragY] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [closing, setClosing] = useState(false);
    const startYRef = useRef(0);

    const closeSheet = () => {
        setClosing(true);
        setTimeout(() => setReviewOverlayOpen(false), 250); // matches the transition time
    };

    const handlePointerDown = (e) => {
        startYRef.current = e.clientY;
        setDragging(true);
        e.currentTarget.setPointerCapture(e.pointerId);
    };

    const handlePointerMove = (e) => {
        if (!dragging) return;
        setDragY(Math.max(0, e.clientY - startYRef.current)); // only allow dragging down
    };

    const handlePointerUp = () => {
        setDragging(false);
        if (dragY > 100) closeSheet();
        else setDragY(0); // snap back
    };

    return (
    <>
    <div className="mobileOverlayBackdrop" onClick={closeSheet} />
    <div
        className="mobileOverlayHalf"
        style={{
            transform: closing ? "translateY(100%)" : `translateY(${dragY}px)`,
            transition: dragging ? "none" : "transform 0.25s ease",
        }}
    >
        <div
            className="mobileOverlayHandleArea"
            onPointerDown={handlePointerDown}
            onPointerMove={handlePointerMove}
            onPointerUp={handlePointerUp}
            onPointerCancel={handlePointerUp}
        >
            <div className="mobileOverlayHandle" />
        </div>

        <div className="mobileOverlayBody">
            <div className="mobileEpisodeReview">
                 <div className="episodePopupDiv">
                    <p>Status</p>
                    <input name="userStatus" value={formData.userStatus} onChange={handleChange} disabled />
                 </div>
                
                <div className="episodePopupDiv">
                    <p>Rating</p>
                     <div className="mobileEpRatingContainer">
                         <div
                            className="mobileEpRating"
                            onMouseLeave={() => setHoverRating(0)}
                        >
                            {[1, 2, 3, 4, 5].map((star) => (
                                <img
                                    key={star}
                                    className="ratingStar"
                                    src={getStarIcon(star, hoverRating || formData.rating)}
                                    alt={`${star} star`}
                                    draggable={false}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onClick={() => handleRatingClick(star)}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="episodePopupDiv">
                    <p>Review</p>
                    <textarea  rows={4} name="note" value={formData.note} onChange={handleChange} />
                </div>

                {/* <div class="episodePopupDiv">
                    <p>Tags</p>
                    <div className="dropdown">
                        <input
                        autoFocus
                        type="text"
                        placeholder="add tag"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && filteredTags.length > 0) {
                            addTag(filteredTags[0]);
                            setQuery("");
                            }
                        }}
                        />
                        {query && (
                        <div className="mobileSearchResults">
                            {filteredTags.length > 0 ? (
                            filteredTags.map((tag) => (
                                <div key={tag} className="" onClick={() => { addTag(tag); setQuery(""); }}>
                                {tag}
                                </div>
                            ))
                            ) : (
                            <div></div>
                            )}
                            <p onClick={() => { addTag(query); setQuery(""); }}>
                            Or add new tag: {query}
                            </p>
                        </div>
                        )}
                    </div>
                    {formData.tags.length > 0 && (
                        <div className="selectedTags">
                            {formData.tags.map((tag) => (
                            <span key={tag} className="tagChip" onClick={() => removeTag(tag)}>
                                {tag} ✕
                            </span>
                            ))}
                        </div>
                    )}
                </div> */}

                <div className="mobileEpisodeReviewButtons">
                    {/* <button onClick={() => setReviewOverlayOpen(false)} className="mobileEpisodeReviewCloseButton">
                        <img src="assets/icons/close-white.png" className="mobileEpisodeReviewCloseIcon"></img>
                    </button> */}
                    <button className="mobileEpisodeReviewSaveButton" onClick={handleSubmit} disabled={loading}>
                         {loading ? "Saving..." : "Save"}
                    </button>
                </div>
                
            </div>
        </div>
    </div>
</>

    )
}